<div
    (click)="navigate()"
    class="d-flex align-items-center">
    <span
        role="button"
        class="padding-1 primary-gradient-bg-300 m-2 clip3">
        <span class="d-flex primary-text secondary-bg-200 primary-text-100 clip3 font-4 py-1 px-4">
            {{ config().name }}
        </span>
    </span>
    <ng-content></ng-content>
</div>
